import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { CollapsableButton } from '../buttons';

const CollapsableContainer = styled.div`
    border: 1px solid ${({ theme, hasErrors }) => hasErrors ? theme.errorColor : theme.borderColor};
    background-color: ${props => props.theme.cardColor};
    margin-bottom: 8px;
    
    > div  {
        padding: 8px 24px 16px;
    }
`;

const StatelessCollapsable = ({ title, subTitle, children, isOpen, handleClick, hasErrors, className }) => (
  <CollapsableContainer hasErrors={hasErrors} className={className}>
    <CollapsableButton
      title={title}
      subTitle={subTitle}
      isOpen={isOpen}
      onClick={handleClick}
      type="button"
      hasErrors={hasErrors}
    />
    {isOpen && <div>{children}</div>}
  </CollapsableContainer>
);


StatelessCollapsable.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  hasErrors: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
};

StatelessCollapsable.defaultProps = {
  hasErrors: false,
};

const Collapsable = ({ openByDefault, ...props }) => {
  const [isOpen, setOpen] = useState(openByDefault);
  return (
    <StatelessCollapsable
      isOpen={isOpen}
      handleClick={() => setOpen(open => !open)}
      {...props} />
  );
};

Collapsable.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  hasErrors: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.instanceOf(Array)]).isRequired,
  openByDefault: PropTypes.bool,
};

Collapsable.defaultProps = {
  hasErrors: false,
  openByDefault: false,
};

export { Collapsable, StatelessCollapsable, CollapsableContainer };

export default Collapsable;
